var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnknownFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.416138V3.91614H10.5L7 0.416138ZM6.125 3.91614V0.416138H1.3125C0.574219 0.416138 0 1.0177 0 1.72864V13.1036C0 13.8419 0.574219 14.4161 1.3125 14.4161H9.1875C9.89844 14.4161 10.5 13.8419 10.5 13.1036V4.79114H7C6.50781 4.79114 6.125 4.40833 6.125 3.91614ZM7.4375 7.88098L6.15234 9.16614L7.4375 10.4786C7.71094 10.7247 7.71094 11.1349 7.4375 11.381C7.19141 11.6544 6.78125 11.6544 6.50781 11.381L5.25 10.0958L3.9375 11.381C3.69141 11.6544 3.28125 11.6544 3.03516 11.381C2.76172 11.1349 2.76172 10.7247 3.03516 10.4513L4.32031 9.16614L3.03516 7.88098C2.76172 7.60754 2.76172 7.19739 3.03516 6.95129C3.28125 6.67786 3.69141 6.67786 3.9375 6.95129L5.25 8.26379L6.53516 6.97864C6.78125 6.7052 7.19141 6.7052 7.4375 6.97864C7.71094 7.22473 7.71094 7.63489 7.4375 7.88098Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnknownFile);
export default __webpack_public_path__ + "static/media/icon_unknown_file.d3418a3e49dd71264821720ea9d69966.svg";
export { ForwardRef as ReactComponent };